<template>
    <div id="ap">
        <a-layout>
            <div class="content-header">
                <a-affix :offset-top="0" style="width: 100%;">
                    <a-row type="flex" justify="space-between">
                        <a-col span="8">
                            <common-page-btn @save="$refs.goodsFormRef.show()" @ExportEx="ExportEx"
                                @category-list="$refs.cateListRef.show()"></common-page-btn>
                        </a-col>
                        <a-col span="16">
                            <a-row type="flex" align="middle" justify="end" :gutter="10">
                                <a-col span="6">
                                    <a-input v-model="param.keyword" allowClear search @pressEnter="getList"
                                        @on-clear="getList" placeholder="关键词查询"></a-input>
                                </a-col>
                                <a-col span="8">
                                    <choose-organ v-model="param.organId" @change="organChange"
                                        allowClear></choose-organ>
                                </a-col>
                                <a-col span="6">
                                    <a-select v-model="param.cateId" placeholder="类别筛选" style="width: 100%"
                                        @change="doRefresh">
                                        <a-select-option :value="item.cateId" v-for="item in category"
                                            :key="item.cateId">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>
                </a-affix>
            </div>
        </a-layout>

        <a-layout>
            <a-layout-content>
                <a-table :defaultExpandAllRows="true" :scroll="{ x: '100%' }" :pagination="false" :indentSize="25"
                    :style="{ background: '#FFF' }" size="small" row-key="goodsId" border :columns="keys" ref="list"
                    :loading="loading" :data-source="data.records">
                    <template slot-scope="row" slot="name">
                        <a-tag color="red">{{ row.goodsType }}</a-tag>
                        <a-tag color="green">{{ row.couponType }}</a-tag>
                        <a href="#">{{ row.title }}</a>
                    </template>
                    <template slot-scope="row" slot="state">
                        <a-tag v-if="row.status == '上架'" color="green">{{ row.status }}</a-tag>
                        <a-tag v-else-if="row.status == '下架'" color="red">{{ row.status }}</a-tag>
                        <a-tag v-else>{{ row.status }}</a-tag>
                    </template>
                    <template slot-scope="row" slot="sort">
                        <a-input-number size="small" v-model="row.sort" @change="(e) => { row.isUpdate = true }"
                            @blur="doSort(row)"></a-input-number>
                    </template>
                    <template slot-scope="row" slot="action">
                        <a-button-group shape="circle" size="small">
                            <a-tooltip title="编辑"><a-button type="link" v-has="'grade-mall:goods:save'" icon="edit"
                                    @click="$refs.goodsFormRef.show(row)"></a-button></a-tooltip>
                            <a-tooltip title="删除"><a-button type="link" v-has="'grade-mall:goods:delete'" icon="delete"
                                    @click="del(row.goodsId)"></a-button></a-tooltip>
                        </a-button-group>
                    </template>
                </a-table>
            </a-layout-content>
        </a-layout>
        <a-row>
            <a-col span="12" offset="6" style="text-align: center; padding: 20px 0;">
                <a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext"
                    @showSizeChange="setLimit" :current="data.current" />
            </a-col>
        </a-row>
        <goods-cate-list ref="cateListRef" @close="getCategory()"></goods-cate-list>
        <goods-form ref="goodsFormRef" :category="category" @success="doRefresh" />
    </div>
</template>

<script>
import apiUtil from "@/common/apiUtil";
import ExporttoExcel from "@/common/ExportExcel.js";
import utils from '@/common/utils';
import goodsCateList from "./components/goods-cate-list.vue";
import goodsForm from './components/goods-form.vue'
export default {
    components: { goodsCateList, goodsForm },
    data() {
        return {
            confirmLoading: false,
            visible: false,
            loading: false,
            isExamine: true,
            cause: '',
            storeId: null,
            status: '',
            data: { records: [] },
            param: {
                page: 1,
                limit: 20,
                keyword: '',
                organId: apiUtil.getDefaultOrganId(),
                cateId: ''
            },
            organList: apiUtil.getOrganList(),
            keys: [
                { title: '名称', scopedSlots: { customRender: 'name' }, ellipsis: true },
                { title: '兑换积分', dataIndex: 'grade', width: 160, align: 'center', ellipsis: true },
                { title: '排序', scopedSlots: { customRender: 'sort' }, width: 160, align: 'center', ellipsis: true },
                { title: '状态', scopedSlots: { customRender: 'state' }, width: 160, align: 'center', ellipsis: true },
                { title: '操作', scopedSlots: { customRender: 'action' }, align: 'center', width: 200 }
            ],
            category: []
        };
    },
    created() {
        this.getCategory();
        this.doRefresh();
    },
    methods: {
        doSort(row) {
            if (row.isUpdate) {
                utils.confirm('您确认要修改排序吗?').then(() => {
                    this.http.post('/platform/grade-mall/goods/save', row).then(ret => {
                        utils.success('修改成功', 1).then(() => {
                            this.doRefresh();
                        })
                    });
                })
            }
        },
        organChange() {
            this.param.cateId = '';
            this.doRefresh();
            this.getCategory();
        },
        getCategory() {
            this.http.get('/platform/grade-mall/category/list', { organId: this.param.organId }).then(ret => {
                this.category = ret.data;
            })
        },
        //删除
        del(id) {
            this.utils.confirm('删除后无法恢复，是否确认?').then(() => {
                utils.showSpin();
                this.http.delete('/platform/grade-mall/goods/delete/' + id).then(ret => {
                    if (ret.code == 200) {
                        this.utils.success('操作成功！').then(() => {
                            this.getList();
                        });
                    }
                });
            });
        },
        // 获取数据
        getList() {
            this.loading = true;
            this.http
                .get('/platform/grade-mall/goods/list', this.param)
                .then(ret => {
                    // console.log(ret);
                    this.data = ret.data;
                }).finally(() => {
                    this.loading = false;
                });
        },
        // 导出excel
        ExportEx() {
            if (this.data.records.length > 0) {
                const filterData = this.data.records.map((item) => {
                    return { '商户名称': item.name, "负责人": item.person, "手机号": item.phone, "地址": item.address, "提交日期": item.createDate, "所属单位": item.organName, "备注": item.remark, "状态": item.status };
                });
                const organ = apiUtil.getOrganList().filter(item => item.organId == this.param.organId);
                let organName = '';
                if (organ.length == 0) {
                    organName = "所有单位";
                } else {
                    organName = organ[0].name;
                }
                ExporttoExcel(filterData, `${organName}商户记录表.xlsx`);
            } else {
                this.$message.info('没有数据哦！！!');
                return;
            }
        },
        doRefresh() {
            this.param.page = 1;
            this.getList();
        },
        //设置每页的显示条数
        setLimit(current, limit) {
            this.param.page = 1;
            this.param.limit = limit;
        },
        //页码切换
        getNext(page) {
            this.param.page = page;
            this.getList();
        }
    }
};
</script>

<style scoped></style>
